const PP59 = [
    {
        "index": 1,
        "content": "こんにちは。最近はどんなことをされてますか？",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 2,
        "content": "最近は新卒で入社した今の会社で働き詰めです。おかげでいつも寝不足ですよ。あなたは？",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 3,
        "content": "勤め人は大変だね。わたしは、何度も転職した結果、自由気ままなフリーランスが性に合ってるってことが分かったよ。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 4,
        "content": "フリーランスかあ。かっこいいなあ。わたしは我慢強いのだけが取り柄だから今の会社でもう少し頑張ろうと思ってるよ。",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 5,
        "content": "えらいなあ。わたしの場合は、敵を作るタイプなんだよねー。原因は多分、わたしにあるんだろうけど。。。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 6,
        "content": "そんなにきつい性格だったかな？",
        "person": "user",
        "role": "normal",
    },
    {
        "index": 7,
        "content": "んー、性格っていうか、リーダーシップを取るのが、自分では得意だと思ってるんだけど、大学中退のくせに偉そうにしてって感じる人も多いみたい。",
        "person": "A",
        "role": "normal",
    },
    {
        "index": 8,
        "content": "ひがみだね。でもそういう人ってどこにでもいるんだよね。性に合うものが見つかってよかったじゃん！",
        "person": "user",
        "role": "scain",
    },
    {
        "index": 9,
        "content": "ありがとう！そう言ってくれると気が晴れるよ。ところで、最近旅行とかしてる？",
        "person": "A",
        "role": "scain",
    },
    {
        "index": 10,
        "content": "全然できてないよー。Bさんはしてる？",
        "person": "user",
        "role": "core",
    },
    {
        "index": 11,
        "content": "うん、最近は忙しいけど、ちょっとした時間を見つけて運動するようにしてるよ。少しでもリフレッシュできるからおすすめだよ。",
        "person": "B",
        "role": "normal",
    },
];

export default PP59;